<template>
  <div ref="content">
    <header id="header" v-if="story.content.header">
      <shared-content :draft="isDraft" :story="story.content.header"></shared-content>
    </header>
    <component id="content" :blok="story.content" :is="story.content.component"></component>
    <footer id="footer" v-if="story.content.footer">
      <shared-content :draft="isDraft" :story="story.content.footer"></shared-content>
    </footer>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
//
import StoryblokClient from "storyblok-js-client";
import SharedContent from "@/_storyblok/components/SharedContent.vue";
import { Promise } from 'q';

const token = process.env.VUE_APP_STORYBLOK_API_KEY;

export default {
  name: "channel",
  components: {
    SharedContent
  },
  data: () => {
    return {
      previous_route: null
    }
  },
  props: {
    dimension: String,
    voucher_code: String
  },
  created() {
    //https://cms.staging.mindfulchef.com/channels/shop/?_storyblok=775174&_storyblok_c=lander&_storyblok_tk%5Bspace_id%5D=56138&_storyblok_tk%5Btimestamp%5D=1559293220&_storyblok_tk%5Btoken%5D=18397a97a4d3f69406648625b139b50632a1c338&_storyblok_version=&_storyblok_release=612
    // _storyblok_release

    this.initStoryBlok(token).then( async storyblok => {
      window.storyblok.init({
        accessToken: token
      });
      const draft = this.isDraft;
      const config = await this.loadConfig();
      const domains = await this.getDataSource('domain-mappings');
      config.data.datasource_entries.map( v => {
          this.setValue({ key: v.name, value: v.value });
      });
      this.setValue({ key: 'domains', value: domains });
      await this.createShopifyService({ 
        domain: this.getValue('shopifyDomain'), 
        token: this.getValue('shopifyAccessToken') });
      this.retrieveOrCreateCheckout();
      window.storyblok.on("change", async () => {
        const route = await this.getPath(this.$route);
        this.getContent(route,draft,window.location.hostname,this.$route.query._storyblok_release);
      });
      window.storyblok.pingEditor(async () => {
        const route = await this.getPath(this.$route);
        this.getContent(route,window.storyblok.isInEditor() || draft,window.location.hostname,this.$route.query._storyblok_release);
      });
      if(this.$props.voucher_code) {
        this.checkVoucher(this.$props.voucher_code)
          .then( v => {
            this.prepareVoucher(this.$props.voucher_code);
          })
          .catch( e => {
            console.error('Invalid voucher code');
          })
      } else {
        this.loadVoucher();
      }
    });
  },
  activated: function() {
    console.log('activated');
  },
  updated: async function() {
    if(this.previous_route!=this.$route.path) {
      const draft = this.isDraft;
      const route = await this.getPath(this.$route);
      this.getContent(route,draft,window.location.hostname,this.$route.query._storyblok_release);
    }
    this.previous_route = this.$route.path;
  },
  methods: {
    ...mapActions("configuration", ["setValue", "getValue"]),
    ...mapActions("shopify", ["createShopifyService","retrieveOrCreateCheckout"]),
    ...mapActions("storyblok", ["initStoryBlok","getStory","loadConfig","getDataSource","getPath"]),
    ...mapActions("recipes", ["loadMealPlans", "loadFoodGroups"]),
    ...mapActions("profile", ["loadProfile"]),
    ...mapActions("voucher", ["checkVoucher", "prepareVoucher","loadVoucher"]),
    getContent: function(route,draft,domain,release) {
      return this.loadMealPlans().then( (v) => {
        this.loadFoodGroups().then( (v) => {
          this.loadProfile();
          this.getStory({ route, draft, domain, release });
          gtag('config', 'GA_MEASUREMENT_ID', {
            'page_path': route
          });
        });
      });
    }
  },
  mounted: function() {
    gtag('config', 'GA_MEASUREMENT_ID', {
      'page_path': this.story.full_slug
    });
  },
  computed: {
    isDraft: function() {
      const isDraft = this.$route.query.draft ? true : (this.$route.query._storyblok != undefined ? true : false);
      return isDraft;
    },
    ...mapState('storyblok',["story"])
  }
};
</script>
